module.exports = __webpack_public_path__ + "static/media/banner.9ec9233b.jpg";